module.exports = __webpack_public_path__ + "fonts/Noto_Sans_TC-300-607.2063b15.woff2";